import httpClient from "../../../shared/api/httpClient";

export const onboardingApi = {
  getStatus: () => httpClient.get("/api/v1/onboarding/status").then((r) => r.data.dados),
};
